export const COMMISSIONS = {
  "en-us": {
    title: "Commissions Dashboard",
    commissionsPaidTitle: "Commissions Paid*",
    commissionsPaidSubtitle: "All time",
    pendingCommissionsUninvoicedTitle: "Pending Commission - Uninvoiced *",
    pendingCommissionsUninvoicedSubtitle: "Invoice still open",
    pendingCommissionsUnpaidTitle: "Pending Commission - Unpaid *",
    pendingCommissionsUnpaidSubtitle: "Invoice delivered waiting payment",
    commissionsDueTitle: "Commission Due *",
    commissionsDueSubtitle: "To be Paid",
    earnedCommissionsOverTimeGraphTitle: "Earned Commission Over Time",
    clientOverviewTitle: "Client Overview",
    fdCommissionsReportTitle: "Fraud Deflect Commission Report",
    filtersNotAppliedToKpi: "*Filters not applied to KPIs",
    clientControl: "Client",
    tablePartner: "Partner",
    tableClient: "Client",
    tableTotalEarned: "Total Earned",
    tableTotalUninvoiced: "Total  Uninvoiced",
    tableTotalUnpaidInvoices: "Total Unpaid Invoices",
    tableTotalCommissionPaid: "Total Commission Paid",
    tableBillingDate: "Billing Date",
    tableGrossRevenue: "Gross Revenue",
    tableGrossProfit: "Gross Profit",
    tableEarnedCommission: "Earned Commissions",
    tableUninvoiced: 'Uninvoiced',
    tableUnpaid: "Unpaid",
    tableCommissionDue: "Commission Due"
  },
  "es-es": {
    title: "Panel de Comisiones",
    commissionsPaidTitle: "Comisiones Pagadas*",
    commissionsPaidSubtitle: "Todo el tiempo",
    pendingCommissionsUninvoicedTitle: "Comisión Pendiente - Sin Facturar *",
    pendingCommissionsUninvoicedSubtitle: "Factura aún abierta",
    pendingCommissionsUnpaidTitle: "Comisión Pendiente - No Pagada *",
    pendingCommissionsUnpaidSubtitle: "Factura entregada, esperando pago",
    commissionsDueTitle: "Comisión Vencida *",
    commissionsDueSubtitle: "Por pagar",
    earnedCommissionsOverTimeGraphTitle: "Comisión Ganada a lo Largo del Tiempo",
    clientOverviewTitle: "Resumen del Cliente",
    fdCommissionsReportTitle: "Informe de Comisiones de Fraud Deflect",
    filtersNotAppliedToKpi: "*Filtros no aplicados a los KPIs",
    clientControl: "Cliente",
    tablePartner: "Socio",
    tableClient: "Cliente",
    tableTotalEarned: "Total Ganado",
    tableTotalUninvoiced: "Total Sin Facturar",
    tableTotalUnpaidInvoices: "Total Facturas No Pagadas",
    tableTotalCommissionPaid: "Total Comisión Pagada",
    tableBillingDate: "Fecha de Facturación",
    tableGrossRevenue: "Ingresos Brutos",
    tableGrossProfit: "Beneficio Bruto",
    tableEarnedCommission: "Comisiones Ganadas",
    tableUninvoiced: 'Sin Facturar',
    tableUnpaid: "No Pagado",
    tableCommissionDue: "Comisión Vencida"
  },
  "pt-br": {
    title: "Painel de Comissões",
    commissionsPaidTitle: "Comissões Pagas*",
    commissionsPaidSubtitle: "Todo o período",
    pendingCommissionsUninvoicedTitle: "Comissão Pendente - Não Faturada *",
    pendingCommissionsUninvoicedSubtitle: "Fatura ainda em aberto",
    pendingCommissionsUnpaidTitle: "Comissão Pendente - Não Paga *",
    pendingCommissionsUnpaidSubtitle: "Fatura entregue, aguardando pagamento",
    commissionsDueTitle: "Comissão Vencida *",
    commissionsDueSubtitle: "A pagar",
    earnedCommissionsOverTimeGraphTitle: "Comissão Ganha ao Longo do Tempo",
    clientOverviewTitle: "Visão Geral do Cliente",
    fdCommissionsReportTitle: "Relatório de Comissões Fraud Deflect",
    filtersNotAppliedToKpi: "*Filtros não aplicados aos KPIs",
    clientControl: "Cliente",
    tablePartner: "Parceiro",
    tableClient: "Cliente",
    tableTotalEarned: "Total Ganho",
    tableTotalUninvoiced: "Total Não Faturado",
    tableTotalUnpaidInvoices: "Total Faturas Não Pagas",
    tableTotalCommissionPaid: "Total Comissão Paga",
    tableBillingDate: "Data de Faturamento",
    tableGrossRevenue: "Receita Bruta",
    tableGrossProfit: "Lucro Bruto",
    tableEarnedCommission: "Comissões Ganhas",
    tableUninvoiced: 'Não Faturado',
    tableUnpaid: "Não Pago",
    tableCommissionDue: "Comissão Vencida"
  },
  "pl-pl": {
    title: "Panel Prowizji",
    commissionsPaidTitle: "Wypłacone Prowizje*",
    commissionsPaidSubtitle: "Cały czas",
    pendingCommissionsUninvoicedTitle: "Oczekująca Prowizja - Niezafakturowana *",
    pendingCommissionsUninvoicedSubtitle: "Faktura nadal otwarta",
    pendingCommissionsUnpaidTitle: "Oczekująca Prowizja - Nieopłacona *",
    pendingCommissionsUnpaidSubtitle: "Faktura dostarczona, oczekuje na płatność",
    commissionsDueTitle: "Prowizja Należna *",
    commissionsDueSubtitle: "Do zapłaty",
    earnedCommissionsOverTimeGraphTitle: "Zarobiona Prowizja w Czasie",
    clientOverviewTitle: "Przegląd Klienta",
    fdCommissionsReportTitle: "Raport Prowizji Fraud Deflect",
    filtersNotAppliedToKpi: "*Filtry nie zostały zastosowane do KPI",
    clientControl: "Klient",
    tablePartner: "Partner",
    tableClient: "Klient",
    tableTotalEarned: "Łącznie Zarobiono",
    tableTotalUninvoiced: "Łącznie Niezafakturowane",
    tableTotalUnpaidInvoices: "Łącznie Nieopłacone Faktury",
    tableTotalCommissionPaid: "Łącznie Wypłacone Prowizje",
    tableBillingDate: "Data Rozliczenia",
    tableGrossRevenue: "Przychód Brutto",
    tableGrossProfit: "Zysk Brutto",
    tableEarnedCommission: "Zarobione Prowizje",
    tableUninvoiced: 'Niezafakturowane',
    tableUnpaid: "Nieopłacone",
    tableCommissionDue: "Należna Prowizja"
  }
};
